var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { flat: "" } },
            [
              _c(
                "v-tabs",
                {
                  attrs: { "show-arrows": "" },
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c("v-tab", { attrs: { href: "#map" } }, [_vm._v("Карта")]),
                  _c("v-tab", { attrs: { href: "#wells" } }, [
                    _vm._v("Графики скважин"),
                  ]),
                  _c("v-tab", { attrs: { href: "#cumulative" } }, [
                    _vm._v("Накопленные графики"),
                  ]),
                  _c("v-tab", { attrs: { href: "#ofp" } }, [
                    _vm._v("Графики ОФП"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-container",
        { staticClass: "d-flex", attrs: { fluid: "" } },
        [
          _c(
            "v-navigation-drawer",
            { attrs: { permanent: "", right: "", height: "100vh" } },
            [
              _c(
                "v-list",
                { attrs: { flat: "", subheader: "" } },
                [
                  _c(
                    "v-list-item",
                    { on: { click: _vm.toggleAllWells } },
                    [
                      _c(
                        "v-list-item-action",
                        [
                          _c("v-checkbox", {
                            attrs: {
                              "input-value":
                                _vm.item && _vm.item.wells
                                  ? _vm.graphWellsIndexes.length ===
                                    _vm.item.wells.length
                                  : false,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Все скважины")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item-group",
                    {
                      attrs: {
                        value: _vm.graphWellsIndexes,
                        multiple: "",
                        "active-class": "",
                      },
                      on: { change: _vm.setCurrentGraphWells },
                    },
                    _vm._l(_vm.allWells, function (well) {
                      return _c("v-list-item", {
                        key: well.value,
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var active = ref.active
                                return [
                                  _c(
                                    "v-list-item-action",
                                    [
                                      _c("v-checkbox", {
                                        attrs: { "input-value": active },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(_vm._s(well.text)),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-tabs-items",
            {
              staticClass: "allow-overflow mb-8 flex-grow",
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c("v-tab-item", { attrs: { value: "map", transition: false } }, [
                _c(
                  "div",
                  { staticClass: "panel-map" },
                  [
                    _vm.mapPanel.title
                      ? _c("h3", {
                          staticClass: "panel-header",
                          domProps: { innerHTML: _vm._s(_vm.mapPanel.title) },
                        })
                      : _vm._e(),
                    _vm.item && _vm.item.reservoir && _vm.isWellsOptimize
                      ? _c("plotly-map", {
                          attrs: {
                            reservoir: _vm.item.reservoir,
                            wells: _vm.graphWells,
                            connections: _vm.connections,
                            "grid-values": _vm.wellsGridValues,
                            "z-coord-prop": "y_coord",
                            grids_y: _vm.item.reservoir.grids_y,
                            dy: _vm.item.reservoir.dy,
                            "time-index": _vm.timeIndex,
                            type: "opt",
                          },
                        })
                      : _vm.item &&
                        _vm.item.reservoir &&
                        _vm.getResult(_vm.mapPanel) &&
                        _vm.gridValues &&
                        !_vm.loading
                      ? _c("plotly-map", {
                          attrs: {
                            reservoir: _vm.item.reservoir,
                            wells: _vm.graphWells,
                            connections: _vm.connections,
                            "grid-values": _vm.gridValues,
                            "z-coord-prop": "y_coord",
                            grids_y: _vm.item.reservoir.grids_y,
                            dy: _vm.item.reservoir.dy,
                            panel: _vm.mapPanel,
                            result: _vm.getResult(_vm.mapPanel),
                            "time-index": _vm.timeIndex,
                            type: "map",
                          },
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "panel-extra" },
                      [
                        _vm.timeScale
                          ? _c("v-slider", {
                              attrs: {
                                min: "0",
                                max: _vm.timeScale.length,
                                "thumb-label": "",
                                ticks: "",
                                "hide-details": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "prepend",
                                    fn: function () {
                                      return [_vm._v(_vm._s(_vm.timeScale[0]))]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "thumb-label",
                                    fn: function (ref) {
                                      var value = ref.value
                                      return [
                                        _vm._v(_vm._s(_vm.timeScale[value])),
                                      ]
                                    },
                                  },
                                  {
                                    key: "append",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          _vm._s(
                                            _vm.timeScale[
                                              _vm.timeScale.length - 1
                                            ]
                                          )
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3967636825
                              ),
                              model: {
                                value: _vm.sliderTime[_vm.mapPanel.id],
                                callback: function ($$v) {
                                  _vm.$set(_vm.sliderTime, _vm.mapPanel.id, $$v)
                                },
                                expression: "sliderTime[mapPanel.id]",
                              },
                            })
                          : _vm._e(),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ml-4",
                            attrs: {
                              elevation: "0",
                              color: "primary",
                              disabled: _vm.isTimeApplied(_vm.mapPanel.id),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.applyPanelTime(_vm.mapPanel.id)
                              },
                            },
                          },
                          [_vm._v("Применить")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "v-tab-item",
                { attrs: { value: "wells", transition: false } },
                [
                  _vm.wellsPanel.title
                    ? _c("h3", {
                        staticClass: "panel-header",
                        domProps: { innerHTML: _vm._s(_vm.wellsPanel.title) },
                      })
                    : _vm._e(),
                  _c("plotly", {
                    attrs: {
                      data: _vm.wellsPlotData,
                      layout: _vm.getPlotLayout(_vm.item, _vm.wellsPanel),
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-tab-item",
                { attrs: { value: "cumulative", transition: false } },
                [
                  _vm.cumulativePanel.title
                    ? _c("h3", {
                        staticClass: "panel-header",
                        domProps: {
                          innerHTML: _vm._s(_vm.cumulativePanel.title),
                        },
                      })
                    : _vm._e(),
                  _c("plotly", {
                    attrs: {
                      data: _vm.cumulativePlotData,
                      layout: _vm.getPlotLayout(_vm.item, _vm.cumulativePanel),
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-tab-item",
                { attrs: { value: "ofp", transition: false } },
                [
                  _vm.ofpPanel.title
                    ? _c("h3", {
                        staticClass: "panel-header",
                        domProps: { innerHTML: _vm._s(_vm.ofpPanel.title) },
                      })
                    : _vm._e(),
                  _c("plotly", {
                    attrs: {
                      data: _vm.ofpPlotData,
                      layout: _vm.getPlotLayout(_vm.item, _vm.ofpPanel),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }